module.exports = __webpack_public_path__ + "img/thumb_05.9a6b0cda.jpg";